@import "@/scss/use-bootstrap-mixins.scss";

// ── DealToggleBar ──

.toggle_bar_container {
  display: flex;
  border-radius: 24px;
  background: #f0f0f0;
  padding: 3px;
  gap: 2px;
  width: 100%;
}

.toggle_bar_scroll {
  display: flex;
  border-radius: 24px;
  background: #f0f0f0;
  padding: 3px;
  gap: 2px;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  position: relative;

  &::-webkit-scrollbar {
    display: none;
  }
}

.scroll_wrapper {
  position: relative;
  width: 100%;
}

.scroll_fade_left,
.scroll_fade_right {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 24px;
  pointer-events: none;
  z-index: 1;
}

.scroll_fade_left {
  left: 0;
  background: linear-gradient(to right, #f0f0f0, transparent);
  border-radius: 24px 0 0 24px;
}

.scroll_fade_right {
  right: 0;
  background: linear-gradient(to left, #f0f0f0, transparent);
  border-radius: 0 24px 24px 0;
}

.segment {
  flex: 1;
  min-width: 0;
  padding: 8px 12px;
  border-radius: 22px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s;
  background: transparent;
  color: #666;
  font-size: 13px;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border: none;
  outline: none;
  font-family: inherit;
}

.segment_scrollable {
  flex: 0 0 auto;
  min-width: 100px;
}

.segment_active {
  background: var(--rs-theme);
  color: var(--rs-text-on-primary, #fff);
  font-weight: 600;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

// ── Detail section ──

.detail_section {
  background: var(--rs-theme-5Pct);
  border-radius: 8px;
  padding: 12px;
  margin-top: 8px;
}

.detail_custom_text {
  font-size: 13px;
  color: #333;
  margin-bottom: 4px;

  &:last-of-type {
    margin-bottom: 8px;
  }
}

.detail_rate {
  font-size: 20px;
  font-weight: 700;
  color: #000;
  margin-bottom: 8px;
}

.detail_descriptions {
  list-style: disc;
  padding-left: 18px;
  margin: 0;

  li {
    font-size: 13px;
    color: #444;
    margin-bottom: 2px;
  }
}

// ── DealToggleBarConfirm (modal) ──

.modal_backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal {
  max-width: 400px;
  width: 90%;
  margin: auto;
  background: #fff;
  border-radius: 16px;
  padding: 24px;
}

.modal_title {
  font-size: 18px;
  font-weight: 700;
  margin: 0 0 16px;
}

.comparison {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
}

.comparison_card {
  flex: 1;
  background: #f5f5f5;
  border-radius: 10px;
  padding: 12px;
  text-align: center;

  .comparison_label {
    display: block;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #888;
    margin-bottom: 4px;
  }

  .comparison_name {
    display: block;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 4px;
    color: #000;
  }

  .comparison_rate {
    display: block;
    font-size: 16px;
    font-weight: 700;
    color: #000;
  }
}

.comparison_arrow {
  flex-shrink: 0;
  font-size: 20px;
  color: #999;
}

.warning_bar {
  background: #fef3cd;
  color: #856404;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 13px;
  margin-bottom: 16px;
  text-align: center;
}

.success_bar {
  background: #d4edda;
  color: #155724;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 13px;
  margin-bottom: 16px;
  text-align: center;
}

.modal_footer {
  display: flex;
  gap: 12px;

  @include media-breakpoint-down(sm) {
    flex-direction: column;
  }
}

.btn_cancel {
  flex: 1;
  padding: 10px 16px;
  border-radius: 10px;
  border: 2px solid #ddd;
  background: transparent;
  color: #333;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  transition: background 0.15s;

  &:hover {
    background: #f5f5f5;
  }
}

.btn_confirm {
  flex: 1;
  padding: 10px 16px;
  border-radius: 10px;
  border: none;
  background: var(--rs-theme);
  color: var(--rs-text-on-primary, #fff);
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  transition: opacity 0.15s;

  &:hover {
    opacity: 0.9;
  }
}
